export enum EJsBridge {
    VALIDATIOIN_TOKEN = "validation_token",
    TELEPHONE = "call",
    MAIL = "mail",
    SHARE_DATA = "share",
    WHATSAPP = "whatsapp",
    CLOSE = "close",
    BACK = "back",
    API_ERROR = "api_error",
    AUTHORIZATION_ERROR = "authorization_error",
    LOADING_COMPLETED = "loadingCompleted",
    SEND_COLOR_STATUS = "healthpatri_status"
}